import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"
import { omit } from "lodash";

// Connects to data-controller="indicaciones-medicas-office-coordinator"
export default class extends Controller {
  static targets = ["formActivas", "formSuspendidas"]

  static values = {
    registro: Number,
    hoja: Number,
    currentDate: String
  }

  submit(e) {
    e.preventDefault();

    const controladorActivas = this.application.getControllerForElementAndIdentifier(
      this.formActivasTarget.querySelector('form'),
      'indicaciones-medicas-office'
    )

    const controladorSuspendidas = this.application.getControllerForElementAndIdentifier(
      this.formSuspendidasTarget.querySelector('form'),
      'indicaciones-medicas-office'
    )

    const indicacionesActivas = controladorActivas ? controladorActivas.indicacionesOffice : []
    const indicacionesSuspendidas = controladorSuspendidas ? controladorSuspendidas.indicacionesOffice : []

    const todasLasIndicaciones = [
      ...indicacionesActivas,
      ...indicacionesSuspendidas
    ].map(indicacionOffice => omit(indicacionOffice, ['persisted']))

    post('/indicaciones_medicas_office/batch_create', {
      responseKind: 'turbo-stream',
      body: {
        Registro: this.registroValue,
        Hoja: this.hojaValue,
        current_date: this.currentDateValue,
        indicaciones_medicas_office: todasLasIndicaciones
      }
    })
  }
}
